package net.bothosting.docs.components.widgets

import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

object SidebarTheme {
    val sidebarWidth = 260.px

    val logoAreaHeight = 55.px
    val logoImageSize = 1.75.cssRem
    val logoImageRadius = 0.3.cssRem
    val logoGap = 0.4.cssRem
    val logoAreaPaddingLeft = 0.75.cssRem

    val navPaddingTop = 1.cssRem
    val navPaddingBottom = 1.cssRem
    val navPaddingLeftRight = 0.55.cssRem
    val navItemGap = 0.15.cssRem
    val navItemPaddingY = 0.25.cssRem
    val navItemPaddingX = 0.55.cssRem
    val navItemGapInner = 0.4.cssRem
    val navItemRadius = 0.35.cssRem

    val sectionLabelPaddingY = 0.25.cssRem
    const val sectionLabelFontSize = 0.6
    const val sectionLabelLetterSpacing = 0.05

    const val navIconFontSize = 0.7
    const val navIconWidth = 1.0
    const val navTextFontSize = 0.78
    const val navExtLinkFontSize = 0.5

    val separatorMarginY = 0.6.cssRem
}
